import * as React from "react";
import Slider, { Settings as SliderSettings } from "react-slick";

import { Wrapper } from "../../../components";
import "./Testimonials.css";

export interface TestimonialsProps {
  settings: SliderSettings;
  bubbleSettings: SliderSettings;
  partnerImgs: React.ReactChild[];
  testimonialImgs: React.ReactChild[];
  children: React.ReactChild[];
  assignRef: (el: Slider) => void;
}

const Testimonials = (props: TestimonialsProps) => (
  <Wrapper>
    <h1 className="title">
      <b>Khách hàng</b> chúng tôi{" "}
      <span>
        <b>Yêu</b>
      </span>
    </h1>

    <div className="row partner-list">{props.partnerImgs}</div>

    <div className="testimonial-background">
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <Slider
            className="testimonial-carousel text-center"
            {...props.settings}
          >
            {props.testimonialImgs}
          </Slider>
        </div>
      </div>
      <div className="row">
        <div className="col-md-offset-2 col-md-8">
          <Slider
            className="testimonial-detail-carousel text-center"
            ref={props.assignRef}
            {...props.bubbleSettings}
          >
            {props.children}
          </Slider>
        </div>
      </div>
    </div>
  </Wrapper>
);

export default Testimonials;



// WEBPACK FOOTER //
// ./src/routes/TestimonialsCarousel/components/Testimonials.tsx